import React from "react";
import { useTheme } from "@mui/material/styles";
import "./loading.css";

const Loading = () => {
  const theme = useTheme();
  return (
    <div
      className="loading"
      style={{
        "--loading-bg": theme.palette.primary.main,
        "--loading-ring1": theme.palette.secondary.main,
        "--loading-ring2": theme.palette.secondary.light,
        "--loading-ring3": theme.palette.primary.light,
      } as React.CSSProperties}
    >
      <div className="loading-spinner"></div>
    </div>
  );
};

export default Loading;
